'use client';

import { useState } from 'react';
import { DescriptionParser } from '@/app_lib/htmlParser/ContentParser';
import { cn } from '@/app_lib/utils/utils';

type Props = {
  content: string;
};

export const AccordionDescription = ({ content }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className='typography-sm pt-2'>
      <div className={cn('overflow-hidden', { '@md:line-clamp-4 line-clamp-2': !isOpen })}>
        <DescriptionParser content={content} />
      </div>
      <button
        aria-label={isOpen ? 'Read Less' : 'Read More'}
        className='my-1 inline-flex cursor-pointer items-center font-semibold text-accent'
        data-cy='accordion-description-toggle'
        onClick={() => setIsOpen(!isOpen)}
        onKeyDown={(e) => {
          if (['Enter', ' '].includes(e.key)) {
            e.preventDefault();
            e.stopPropagation();
            setIsOpen(!isOpen);
          }
        }}
        type='button'
      >
        <span className='uppercase'>Read {isOpen ? 'Less' : 'More'}</span>
        <span
          className={cn('icon icon-arrow-down mt-1 h-8 w-8', {
            'mt-0 rotate-180 transform': isOpen,
          })}
        />
      </button>
    </div>
  );
};
